import gql from 'graphql-tag';

export const GET_NTM_DETAILS = gql`
  query getNtmDetails ($startTime:String, $endTime:String, $traceIds:[String]) {
    getNtmTraceDetails(startTime:$startTime, endTime:$endTime, traceIds:$traceIds) {
      traceId,
      code,
      timestamp,
      Message,
      message
    }
  }
`;

export const GET_CALL_STATISTICS_ALL = gql`
  {
    getCallServicesHealth {
      env,
      servertype,
      avg,
      time_bucket,
      objectId,
      createdAt,
      updatedAt
    }
  }
`;
